import React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'

import { useAppSelector } from '../../../store/hooks'
import { BaseContract } from '../../../store/slices/contractSlice'
import ContractOffers from '../../organisms/ContractOffers'

type TarifNewProps = {
  nextPage: string,
  prevPage: string,
  changeActivePage: (pageUrl: string) => void
}

const Component = ({ nextPage, prevPage, changeActivePage }: TarifNewProps) => {
  const baseContract = useAppSelector(state => state.contract.baseContract)
  const productDetails = useAppSelector(state => state.productdetail)
  const productReduceCharges = productDetails.paragraph14aCompatible

  const checkValidOfferAndChangePage = (pageUrl: string, baseContractOffer: BaseContract) => {
    if (!baseContractOffer.type) {
      changeActivePage(pageUrl)
    } else {
      alert('Leider können wir Ihnen für die angegebene Postleitzahl kein Angebot unterbreiten.')
    }
  }

  return (
    <div className="react-form__page react-form__page--tarif">
      <ContractOffers productReduceCharges={productReduceCharges} />
      <div className="clearfix bg-gray-lighter px-5 py-10">
        {prevPage && (
          <qz-button
            class="float-left"
            onClick={() => changeActivePage(prevPage)}
          >
            Zurück
          </qz-button>
        )}
        {nextPage && (
          <qz-button
            class="float-right"
            onClick={() => checkValidOfferAndChangePage(nextPage, baseContract)}
            buttonType="submit"
          >
            Jetzt Angebot&nbsp;
            <br className="sm:hidden" />
            abschließen
          </qz-button>
        )}
      </div>
    </div>
  )
}

export default Component
